import {PropsWithChildren, useEffect, useState} from "react";
import {RealtimeContext} from "@/api/realtime/RealtimeHooks.ts";
import {createRealtimeClient} from "@/api/realtime/WebSocketClient.ts";

export function RealtimeProvider({children}: PropsWithChildren) {
    const [client] = useState(createRealtimeClient);

    useEffect(() => {
        client.connect();
        return () => void client.disconnect();
    }, [client]);

    return <RealtimeContext.Provider value={client}>{children}</RealtimeContext.Provider>;
}
